import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { PrimeNG } from 'primeng/config';
 import Aura from '@primeng/themes/aura';
import { TenantConfigEntity, TenantService } from './plateformebeneficiaire/core';
import Common from './layout/themes/common';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    tenant: TenantConfigEntity | null = null;


    constructor(
        private primengConfig: PrimeNG,
        private tenantService: TenantService,
        private swUpdate: SwUpdate
    ) {
        this.tenant = tenantService.getTenant();
        console.log('tenant', this.tenant?.name);
        this.applyTheme(this.tenant?.name);

        // Service Worker: Force update check and reload if new version is available
        if (this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates.subscribe(() => {
                this.swUpdate.activateUpdate().then(() => document.location.reload());
            });
            this.swUpdate.checkForUpdate();
        }
    }


    applyTheme(tenantName: string = "") {
        let tenantPreset = Common;
        switch (tenantName) {
        //   /////////////
        //   // LOCAL
        //   /////////////
        //   case 'sstrn-local':
        //     tenantPreset = LocalSSTRN;
        //     break;

        /////////////
        // DEVELOPMENT
        /////////////
        //   case 'ressif-dev':
        //     tenantPreset = DevelopmentRESSIF;
        //     break;
        //   case 'sstrn-dev':
        //     tenantPreset = DevelopmentRESSIF;
        //     break;
        //   case 'talpia-dev':
        //     tenantPreset = DevelopmentTALPIA;
        //     break;

        default:
            tenantPreset = Common;
            break;
        }


        this.primengConfig.zIndex = {
          modal: 1100, 
          overlay: 1000, 
          menu: 1000, 
          tooltip: 1100
        };
        this.primengConfig.theme.set({
            preset: tenantPreset,
            options: {
                darkModeSelector: '.app-dark',
                cssLayer: {
                    name: 'primeng',
                    order: 'tailwind-base, primeng, tailwind-utilities'
                }
            }
        })
    }
}

